var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataCenterDatabaseHostingSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,23.8362v48c0,15.7617,24.1465,24,48,24s48-8.2383,48-24v-48C96-7.6873,0-7.6873,0,23.8362Zm84,24c0,4.23-13.67,12-36,12s-36-7.77-36-12V40.0645c9.2527,5.0778,22.5938,7.7717,36,7.7717s26.7473-2.6939,36-7.7717Zm-36-36c22.33,0,36,7.7695,36,12s-13.67,12-36,12-36-7.7695-36-12S25.67,11.8362,48,11.8362Zm0,72c-22.33,0-36-7.77-36-12V64.0645c9.2527,5.0778,22.5938,7.7717,36,7.7717s26.7473-2.6939,36-7.7717v7.7717C84,76.0667,70.33,83.8362,48,83.8362Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataCenterDatabaseHostingSvgrepoCom);
export default __webpack_public_path__ + "static/media/data-center-database-hosting-svgrepo-com.628092603f422c7e04cc8ac8ea94aac6.svg";
export { ForwardRef as ReactComponent };